import { useContext, useEffect, useState } from "react";
// import styles from "./LoginPage.module.css";
import { AuthContext } from "react-oauth2-code-pkce";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import {
  BASE_URL,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID
} from "../../constants/constant";
import { Service } from "../../services/service";
import Loader from "../../components/loader/Loader";
import { useJwt } from "react-jwt";
const service = new Service();

const Login = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("bb_access_token");
  const { decodedToken, isExpired } = useJwt(token);
  const { login } = useContext(AuthContext);
  const searchParams = localStorage.getItem("searchParams");
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  if (location.pathname) {
    localStorage.setItem("searchParams", location.pathname);
  } else {
    localStorage.removeItem("searchParams");
  }

  const checkLogin = () => {
    var user_data = localStorage.getItem("user_data");
    if (!user_data) {
      navigate("/login");
    }
    else {
      var currPath = window.location.pathname;
      var user_data_obj = JSON.parse(user_data);
      if (user_data_obj && user_data_obj.environments) {
        var environment_id = user_data_obj?.environments[0]?.environmentId;
        if (token && !isExpired) {
          navigate("/dashboard");
        }
        else {

        }
      }
      else if (currPath === "/" && !user_data_obj.roles.some(e => e.roleId == USER_ROLE_ID)) {
        navigate("/accessdenied")
      }
      else if (currPath === "/admin" && user_data_obj.roles.some(e => e.roleId == VF_ADMIN_ROLE_ID)) {
        navigate("/dashboard");
      }
    }
  };
  // const refreshAccessToken = async (environment_id) => {
  //   setLoading(true);
  //   let url =
  //     `${BASE_URL}/api/Environment/RefreshEnvironmentAccessToken?environmentId=` + environment_id;
  //   const user_token = localStorage.getItem("bb_access_token");
  //   try {
  //     let data = await service.testPutApi(url, {}, user_token);
  //     let resp = data;
  //     console.log("resp", resp);
  //     if (resp?.data?.data && resp?.status == 200) {
  //       setLoading(false);
  //       navigate("/dashboard");
  //     } else {
  //       setLoading(false);
  //       login();
  //     }
  //   } catch (err) {
  //     setLoading(false);
  //     console.log(err);
  //     login();
  //   }
  // };
  useEffect(() => {
    if (!token && location.pathname !== "/admin") {
      navigate("/home");
    } else {
      checkLogin();
    }
  }, []);

  if (loading) return <Loader />;
  return null;
};


export default Login;
